import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, tap} from "rxjs";
import {FormDto, GetFormMetadata_Request, OrtakService} from "@dabnet-kamu/libs/ui";

@Injectable({
  providedIn: 'root'
})
export class FormMetadataService {
  private formMetadataMap: { [key: string]: BehaviorSubject<FormDto | null> } = {};

  constructor(private ortakService: OrtakService) {}

  getFormMetaData(key: string, formData?: Partial<GetFormMetadata_Request>): Observable<FormDto | null> {
    // Key ve formAd üzerinde / karakterinden sonrasını almak
    const updatedKey = key?.slice(key?.lastIndexOf("/") + 1);
    const updatedFormAd = formData?.formAd?.slice(formData.formAd.lastIndexOf("/") + 1) || '';

    if (!this.formMetadataMap[updatedKey]) {
      this.formMetadataMap[updatedKey] = new BehaviorSubject<FormDto | null>(null);
    }

    const request = new GetFormMetadata_Request({
      formAd: updatedKey? updatedKey:updatedFormAd,
      altFormAd: formData?.altFormAd || '',
      kod: formData?.kod || 0,
      logYn: formData?.logYn || false,
    });

    this.ortakService.getFormMetadata(request).pipe(
      tap((response) => {
        this.formMetadataMap[updatedKey].next(response.formMetadata);
      })
    ).subscribe();

    return this.formMetadataMap[updatedKey].asObservable();
  }

  getFormMetadataObservable(key: string): Observable<FormDto | null> {
    const updatedKey = key?.slice(key?.lastIndexOf("/") + 1);

    if (!this.formMetadataMap[updatedKey]) {
      this.formMetadataMap[updatedKey] = new BehaviorSubject<FormDto | null>(null);
    }
    return this.formMetadataMap[updatedKey].asObservable();
  }
  // BehaviorSubject'i temizlemek için
  clearFormMetaData(key: string): void {
    const updatedKey = key?.slice(key?.lastIndexOf("/") + 1);
    if (this.formMetadataMap[updatedKey]) {
      this.formMetadataMap[updatedKey].complete();
      delete this.formMetadataMap[updatedKey];
    }
  }
}
